import axios from 'axios';
import store from 'redux/store';
import { showLoginModal } from 'redux/ui/uiSlice';

const axiosInstance = axios.create({
	baseURL: "", // Base URL will be resolved by the IIS server
	withCredentials: true, // Include cookies if needed
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
	(response) => response,
	async (error) => {
		// Check if the error is a 403 Forbidden due to session expiration
		if (
			error.response?.status === 403 &&
			error.response?.data?.Message ===
				'Session ended for the current user. Please login to continue.'
		) {
			console.warn('Session expired. Prompting user to re-authenticate.');

			// Dispatch an action to show the login modal
			store.dispatch(showLoginModal());

			// Prevent further errors by rejecting the promise
			return Promise.reject(
				new Error('Session expired. Please log in again.'),
			);
		}

		return Promise.reject(error);
	},
);

export default axiosInstance;
